export default __webpack_public_path__ + "static/media/204.5827836d.svg";